import React from 'react';
import Neededdocuments from '../../../assets/Service-icon/needed documents.svg';
import Visaassist from '../../../assets/Service-icon/visa assist.svg';
import Visaprocess from '../../../assets/Service-icon/Visa process.svg';
import Track from '../../../assets/Service-icon/track.svg';

const Steps = () => {
  const options = [
    {
      id: 1,
      img: Neededdocuments,
      step: 'Step 1',
      desc: 'Provide required visa detail & receive list of needed documents',
    },
    {
      id: 2,
      img: Visaassist,
      step: 'Step 2',
      desc: 'We assist with your visa application',
    },
    {
      id: 3,
      img: Visaprocess,
      step: 'Step 3',
      desc: 'We process your visa application and submit it to the consulate/embassy',
    },
    {
      id: 4,
      img: Track,
      step: 'Step 4',
      desc: 'We track and update you on your visa status',
    },
  ];

  return (
    <div className='mb-10 px-4 pt-10 text-center'>
      {/* Main Heading */}
      <h1 className='mb-12 text-3xl font-extrabold leading-snug text-gray-900 md:text-6xl'>
        Get Your Visa In 4 Easy Steps
      </h1>

      {/* Grid */}
      <div className='mx-auto grid max-w-7xl grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-4'>
        {options.map((item) => (
          <div
            key={item.id}
            className='service_card flex flex-col items-center rounded-lg'
          >
            <img
              src={item.img}
              alt={item.step}
              className='mb-4 h-24 w-24 object-contain'
            />
            <h3 className='text-dark mb-2 text-xl font-semibold md:text-2xl'>{item.step}</h3>
            <p className='text-justify leading-relaxed text-gray-700'>{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Steps;
